import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploadCsvDropzoneHeading: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-csv-dropzone.upload-csv-dropzone-heading',
		defaultMessage: 'Import from CSV',
		description: 'Import from CSV heading',
	},
	uploadFooterContinue: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-csv-dropzone.upload-footer-continue',
		defaultMessage: 'Continue',
		description: 'Continue button',
	},
	uploadFooterCancel: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-csv-dropzone.upload-footer-cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button',
	},
});
